import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import {addZeroes} from '@/utils'
import {EcospendBlock} from '../EcospendBlock'
import {EcospendField} from '../EcospendField'
import {EcospendBankBlockProps} from './props'
import styles from './EcospendBankBlock.scss'

export const EcospendBankBlock: React.FC<EcospendBankBlockProps> = (props) => {
    const { t } = useTranslation()
    const {className, friendlyName, invoiceId, amount} = props

    return <EcospendBlock className={classNames(styles.ecospendBankBlock, className)}>
        <EcospendField className={styles.bankField} label={t('EcospendBankBlock.bank')}>
            {friendlyName}
        </EcospendField>
        <EcospendField className={styles.bankField} label={t('EcospendBankBlock.amount')}>
            {addZeroes(amount)}
        </EcospendField>
        <EcospendField className={styles.bankField} label={t('EcospendBankBlock.reference')}>
            {invoiceId}
        </EcospendField>
    </EcospendBlock>
}
